import React, { useEffect, useRef, useState } from "react";
import { GetStaticProps, InferGetStaticPropsType } from "next";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useAppDispatch, useAppSelector } from "@/redux/app/hooks";
import { isTryDemoViewableRedux, setIsTryDemoViewable } from "@/redux/slices/user-context";
import Image, { ImageLoaderProps } from "next/image";
import Link from "next/link";
import StoneityButton from "@/components/stoneity-button/stoneityButton";
import styles from "../styles/Header.module.css";
import Global from "./images/global";
import useIsLargeScreen from "@/base/hooks/useIsLargeScreen";
import { IMAGE_DELIVERY, imageLoader } from "@/base/utils/dataHelper";
import Forest from "./images/forest";
import ProductsIcon from "./images/productsIcon";
import ProductRightArrow from "./images/productRightArrow";
import SolutionIcon from "./images/solutionIcon";
import Arrow from "./images/arrow";

interface HeaderProps {
  logo?: "original" | "green";
  theme?: string;
  color?: string;
}

const productsData = [
  {
    id: "p1",
    title: "Work Management",
    color: "#FC584A",
    explain: "projectAndTaskDescription",
    buttonText: "goToWorkManagement",
    link: "/work-management",
    // cards: [
    //   {
    //     title: "Görevler",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Görevler",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Görevler",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Görevler",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Görevler",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    // ]
  },
  {
    id: "p2",
    title: "Service Management",
    color: "#478B5A",
    explain: "requestAndSupportDescription",
    buttonText: "goToServiceManagement",
    link: "/service-management",
    // cards: [
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    //   {
    //     title: "Talep",
    //     desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
    //     link: "",
    //   },
    // ]
  },
  {
    id: "p3",
    title: "demoLibrary",
    explain: "exploreStoneityLibraries",
    color: "",
    icon: false,
    library: true,
    buttonText: "",
    cards: [
      {
        img: "29b26a6e-57dd-48cd-4c50-88746fc04700",
        title: "Portal",
        desc: "portalDemoStep1Text",
        link: "/demo-pages?type=portal",
      },
      {
        img: "7e3a1011-1d6d-49c8-6394-ca3795290e00",
        title: "Agent",
        desc: "stoneityProjectJourney",
        link: "/demo-pages?type=agent",
      },
    ]
  },
  {
    id: "p4",
    title: "ITSM",
    explain: "aiPoweredOrchestration",
    color: "",
    icon: false,
    logo: "/bmc-helix-logo.svg",
    library: true,
    buttonText: "goToBmcHelixItsm",
    link: "/bmc-helix-itsm",
  },
  {
    id: "p5",
    title: "Discovery",
    explain: "integratedAiDrivenServiceManagement",
    color: "",
    icon: false,
    logo: "/bmc-helix-logo.svg",
    library: true,
    buttonText: "goToBmcHelixDiscovery",
    link: "/bmc-helix-discovery",
  },
  {
    id: "p6",
    title: "Control-M",
    explain: "unlockVisibilityAndControl",
    color: "",
    icon: false,
    logo: "/bmc-logo.svg",
    library: true,
    buttonText: "goToBmcControlM",
    link: "/bmc-control-m",
  }
];

const solutionsData = [
  {
    id: "s1",
    title: "itsm",
    explain: "itServiceOperationsSolutions",
    icon: false,
    buttonText: "",
    cards: [
      {
        title: "incidentManagement",
        desc: "incidentManagementDescription",
        link: "/solutions/itsm-incident-management"
      },
      {
        title: "problemManagement",
        desc: "problemManagementDescription",
        link: "/solutions/itsm-problem-management"
      },
      // {
      //   title: "taskManagement",
      //   desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
      //   link: "/solutions/itsm-task-management"
      // },
      {
        title: "requestManagement",
        desc: "requestManagementDescription",
        link: "/solutions/itsm-request-management"
      },
      {
        title: "changeManagement",
        desc: "changeManagementDescription",
        link: "/solutions/itsm-change-management"
      },
      {
        title: "selfServicePortal",
        desc: "selfServicePortalDescription",
        link: "/solutions/itsm-self-service-portal"
      },
      {
        title: "serviceAutomation",
        desc: "serviceAutomationDescription",
        link: "/solutions/itsm-service-automation"
      },
      // {
      //   title: "esmEnterpriseServiceManagement",
      //   desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
      //   link: "/solutions/itsm-esm-enterprise-service-management"
      // },
      // {
      //   title: "contractManagement",
      //   desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
      //   link: "/solutions/itsm-contract-management"
      // },
      // {
      //   title: "workflowManagement",
      //   desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
      //   link: "/solutions/itsm-workflow-management"
      // },
    ]
  },
  {
    id: "s2",
    title: "customerServiceManagementTitle",
    explain: "customerServiceSolutionsDescription",
    icon: false,
    buttonText: "",
    cards: [
      {
        title: "customerServiceManagement",
        desc: "customerServiceManagementDescription",
        link: "/solutions/csm-customer-service-management"
      },
      // {
      //   title: "fieldServiceManagement",
      //   desc: "Lorem ipsum dolor sit amet, consetetur adipiscing elit.",
      //   link: "/solutions/csm-field-service-management"
      // },
      {
        title: "salesAndOrderManagement",
        desc: "salesAndOrderManagementDescription",
        link: "/solutions/csm-sales-and-order-management"
      },
    ]
  },
  {
    id: "s3",
    title: "esmEnterpriseServiceManagement",
    explain: "nonItServiceSolutions",
    icon: false,
    buttonText: "",
    cards: [
      {
        title: "hrServiceDelivery",
        desc: "hrServiceDeliveryDescription",
        link: "/solutions/ee-hr-service-delivery"
      },
      {
        title: "workspaceServiceDelivery",
        desc: "workspaceServiceDeliveryDescription",
        link: "/solutions/ee-workspace-service-delivery"
      },
      {
        title: "esmEnterpriseServiceManagement",
        desc: "esmEnterpriseServiceManagementDescription",
        link: "/solutions/ee-enterprise-service-management"
      },
      {
        title: "fieldServiceManagement",
        desc: "fieldServiceManagementDescription",
        link: "/solutions/ee-field-service-management"
      },
    ]
  },
  {
    id: "s4",
    title: "projectAndStrategyManagement",
    explain: "projectStrategySolutionsDescription",
    icon: false,
    buttonText: "",
    cards: [
      {
        title: "projectPortfolio",
        desc: "projectPortfolioDescription",
        link: "/solutions/pasm-project-portfolio"
      },
      {
        title: "projectPlanning",
        desc: "projectPlanningDescription",
        link: "/solutions/pasm-project-planning"
      },
      {
        title: "okr",
        desc: "okrDescription",
        link: "/solutions/pasm-okr"
      },
      {
        title: "capacityPlanning",
        desc: "capacityPlanningDescription",
        link: "/solutions/pasm-capacity-planning"
      },
      {
        title: "projectTracking",
        desc: "projectTrackingDescription",
        link: "/solutions/pasm-project-tracking"
      },
      {
        title: "strategicInitiative",
        desc: "strategicInitiativeDescription",
        link: "/solutions/pasm-strategic-initiative"
      },
    ]
  },
  {
    id: "s5",
    title: "workflowAndOperations",
    explain: "workflowOperationsDescription",
    icon: false,
    buttonText: "",
    cards: [
      {
        title: "workflowManagement",
        desc: "workflowManagementDescription",
        link: "/solutions/wm-workflow-management"
      },
      {
        title: "taskManagement",
        desc: "taskManagementDescription",
        link: "/solutions/wm-task-management"
      },
      {
        title: "contractManagement",
        desc: "contractManagementDescription",
        link: "/solutions/wm-contract-management"
      },
      {
        title: "accountsPayableOperations",
        desc: "accountsPayableOperationsDescription",
        link: "/solutions/wm-account-payable-operations"
      },
    ]
  },
];

const Header = (_props: InferGetStaticPropsType<typeof getStaticProps> & HeaderProps) => {
  const { logo, theme, color } = _props;

  const { t } = useTranslation('common');
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();
  const { isLargeScreen } = useIsLargeScreen("(min-width: 1200px)");
  const dispatch = useAppDispatch();
  const isTryDemoViewable = useAppSelector(isTryDemoViewableRedux);
  const responsiveMenuRef = useRef<HTMLDivElement>(null);
  const languageMenuRef = useRef<HTMLDivElement>(null);
  const sourcesMenuRef = useRef<HTMLDivElement>(null);
  const readyMadeWorkflowMenuRef = useRef<HTMLDivElement>(null);
  const [isResponsiveMenuOpen, setIsResponsiveMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isSourcesMenuOpen, setIsSourcesMenuOpen] = useState(false);
  const [isReadyMadeWorkflowMenuOpen, setIsReadyMadeWorkflowMenuOpen] = useState(false);
  const logoType = logo || 'original';
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSolutionOpen, setIsSolutionOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<"up" | "down" | null>(null);
  const [isResponsiveScrollMenu, setIsResponsiveScrollMenu] = useState(false);
  const [isResponsiveSourcesScrollMenu, setIsResponsiveSourcesScrollMenu] = useState(false);
  const [isResponsiveFeaturesScrollMenu, setIsResponsiveFeaturesScrollMenu] = useState(false);
  const [isResponsiveSolutionsScrollMenu, setIsResponsiveSolutionsScrollMenu] = useState(false);
  const [isResponsivePlanScrollMenu, setIsResponsivePlanScrollMenu] = useState(false);
  const [isResponsiveWorkflowScrollMenu, setIsResponsiveWorkflowScrollMenu] = useState(false);
  const [activeData, setActiveData] = useState(productsData[0]);

  const [isReponsiveWorkManagementSubMenuOpen, setIsReponsiveWorkManagementSubMenuOpen] = useState(false);
  const [isReponsiveServiceManagementSubMenuOpen, setIsReponsiveServiceManagementSubMenuOpen] = useState(false);
  const [isReponsiveDemoLibrarySubMenuOpen, setIsReponsiveDemoLibrarySubMenuOpen] = useState(false);

  const [isDemoLibraryFirst, setIsDemoLibraryFirst] = useState(false);
  const [isDemoLibrarySecond, setIsDemoLibrarySecond] = useState(false);
  const [isDemoLibraryThird, setIsDemoLibraryThird] = useState(false);
  const [isDemoLibraryFourth, setIsDemoLibraryFourth] = useState(false);
  const [isDemoLibraryFifth, setIsDemoLibraryFifth] = useState(false);

  useEffect(() => {
    const handleRouteChange = () => setIsMenuOpen(false);

    router.events.on("routeChangeStart", handleRouteChange);
    return () => router.events.off("routeChangeStart", handleRouteChange);
  }, [router.events]);

  const responsiveMenuTabClose = () => {
    setIsResponsiveScrollMenu(false);
    setIsResponsiveSourcesScrollMenu(false);
    setIsResponsiveFeaturesScrollMenu(false);
    setIsResponsivePlanScrollMenu(false);
    setIsResponsiveWorkflowScrollMenu(false);
    setIsResponsiveSolutionsScrollMenu(false);
  }

  const responsiveProductMenuTabClose = () => {
    setIsReponsiveWorkManagementSubMenuOpen(false);
    setIsReponsiveServiceManagementSubMenuOpen(false);
    setIsReponsiveDemoLibrarySubMenuOpen(false);
  }

  const responsiveDemoLibraryMenuTabClose = () => {
    setIsDemoLibraryFirst(false);
    setIsDemoLibrarySecond(false);
    setIsDemoLibraryThird(false);
    setIsDemoLibraryFourth(false);
    setIsDemoLibraryFifth(false);
  }

  const lastScrollRef = useRef<number>(0);

  useEffect(() => {
    lastScrollRef.current = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const lastScrollY = lastScrollRef.current;

      if (currentScrollY > lastScrollY) {
        setScrollDirection((prev) => (prev !== "down" ? "down" : prev));
      } else if (currentScrollY < lastScrollY) {
        setScrollDirection((prev) => (prev !== "up" ? "up" : prev));
      }

      setIsScrolled(currentScrollY > 0);
      lastScrollRef.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const workMagamentPathname = router.pathname.startsWith("/work-management")
  const serviceMagamentPathname = router.pathname.startsWith("/service-management")
  // Innerbox şimdilik kullanılmıyor, ama ileride tekrar açılabilir
  // const innerboxPathname = router.pathname.startsWith("/innerbox")

  const menuClose = () => {
    setIsMenuOpen(false);
    setIsLanguageMenuOpen(false);
    setIsResponsiveMenuOpen(false);
    setIsSourcesMenuOpen(false);
  }

  useEffect(() => {
    dispatch(setIsTryDemoViewable(isLargeScreen || false));
  }, [isLargeScreen]);

  useEffect(() => {
    const handler = (e: any) => {
      if (responsiveMenuRef.current && !responsiveMenuRef.current.contains(e.target)) {
        setIsResponsiveMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, []);

  useEffect(() => {
    const handler = (e: any) => {
      if (languageMenuRef.current && !languageMenuRef.current.contains(e.target)) {
        setIsLanguageMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, []);

  useEffect(() => {
    const handler = (e: any) => {
      if (sourcesMenuRef.current && !sourcesMenuRef.current.contains(e.target)) {
        setIsSourcesMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, []);

  useEffect(() => {
    const handler = (e: any) => {
      if (readyMadeWorkflowMenuRef.current && !readyMadeWorkflowMenuRef.current.contains(e.target)) {
        setIsReadyMadeWorkflowMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, []);

  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (activeData.id === "p3" && windowWidth < 1300) {
      setActiveData(productsData[0]);
    }
  }, [activeData, windowWidth, productsData]);

  const handleItemClick = (item) => {
    if (item.id === "p3" && windowWidth < 1300) {
      setActiveData(productsData[0]);
    } else {
      setActiveData(item);
    }
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          {
            windowWidth > 890 ? (
              isScrolled && (workMagamentPathname || serviceMagamentPathname) ? (
                workMagamentPathname ? (
                  <div className={`${styles.headerContentLeft} ${styles.navbarProductsContent} ${isScrolled ? styles.navbarProductsContentActive : ""}`}>
                    <div className={styles.headerProducts}>
                      <Link className={`${styles.headerProductsLogo}`} href={"/work-management"}>
                        <ProductsIcon color="#FC584A" />
                        Work Management
                      </Link>
                      <div className={`${styles.headerProductsMenu} ${isScrolled ? styles.headerProductsMenuActive : ""}`}>
                        <Link className={`${styles.menuLink} ${router.pathname.endsWith("/features") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/work-management/features"}>{t('features')}</Link>
                        <Link className={`${styles.menuLink} ${router.pathname.endsWith("/plan") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/work-management/plan"}>{t('plans')}</Link>
                        <Link className={`${styles.menuLink} ${router.pathname.endsWith("/documents") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/work-management/documents"}>{t('documents')}</Link>
                        {/* <Link className={`${styles.menuLink} ${router.pathname.endsWith("/template") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/work-management/template"}>Template</Link> */}
                      </div>
                    </div>
                  </div>
                ) : serviceMagamentPathname ? (
                  <div className={`${styles.headerContentLeft} ${styles.navbarProductsContent}`}>
                    <div className={styles.headerProducts}>
                      <Link className={`${styles.headerProductsLogo}`} href={"/service-management"}>
                        <ProductsIcon color="#478B5A" />
                        Service Management
                      </Link>
                      <div className={`${styles.headerProductsMenu} ${isScrolled ? styles.headerProductsMenuActive : ""}`}>
                        {/* <Link className={`${styles.menuLink} ${router.pathname.endsWith("/features") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/service-management/features"}>{t('features')}</Link> */}
                        <Link className={`${styles.menuLink} ${router.pathname.endsWith("/plan") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/service-management/plan"}>{t('plans')}</Link>
                        <Link className={`${styles.menuLink} ${router.pathname.endsWith("/documents") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/service-management/documents"}>{t('documents')}</Link>
                        {/* <Link className={`${styles.menuLink} ${router.pathname.endsWith("/template") ? styles.menuLinkActive : ""} ${styles[theme ?? '']}`} locale={router.locale} href={"/service-management/template"}>Template</Link> */}
                      </div>
                    </div>
                  </div>
                ) : null
              ) : (
                <div className={styles.headerContentLeft}>
                  <Link className={styles.headerLogoWrapper} href={"/"} aria-label={t('homepageLinkLabel')}>
                    <Image
                      src={logoType === "original" ? "/stoneityLogo.png" : logoType === "green" ? "/stoneityLogoGreen.png" : ""}
                      className={styles.headerLogo}
                      alt=""
                      width={130}
                      height={32}
                      sizes="130px"
                    />
                  </Link>
                  <div className={styles.menuLink} onClick={() => { setIsMenuOpen(true) }}>{t("solutions")}</div>
                  {/* <div className={styles.menuLinkWrapper} ref={readyMadeWorkflowMenuRef}>
                    <div className={styles.menuLink}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsReadyMadeWorkflowMenuOpen(true);
                      }}>
                      {t("readyMadeWorkflow")}
                    </div>
                    <div className={`${styles.readyMadeWorkflowMenuContent} ${isReadyMadeWorkflowMenuOpen ? styles.readyMadeWorkflowMenuContentActive : ""}`}>
                      <Link className={styles.headerProductsLogo} href={"/work-management/template"}>
                        <ProductsIcon width="24px" height="24px" color="#FC584A" />
                        Work Management Template
                      </Link>
                      <Link className={styles.headerProductsLogo} href={"/service-management/template"}>
                        <ProductsIcon width="24px" height="24px" color="#478B5A" />
                        Service Management Template
                      </Link>
                    </div>
                  </div> */}
                  <div className={styles.menuLinkWrapper} ref={sourcesMenuRef}>
                    <div className={styles.menuLink}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsSourcesMenuOpen(true);
                      }}>
                      {t("sources")}
                    </div>
                    <div className={`${styles.sourcesMenuContent} ${isSourcesMenuOpen ? styles.sourcesMenuContentActive : ""}`}>
                      <Link className={styles.headerProductsLogo} href={"/work-management/documents"}>
                        <ProductsIcon width="24px" height="24px" color="#FC584A" />
                        Work Management Docs
                      </Link>
                      <Link className={styles.headerProductsLogo} href={"/service-management/documents"}>
                        <ProductsIcon width="24px" height="24px" color="#478B5A" />
                        Service Management Docs
                      </Link>
                    </div>
                  </div>
                </div>
              )
            ) : null
          }
          {windowWidth < 891 ?
            <div className={styles.headerContentLeft}>
              <Link className={styles.headerLogoWrapper} href={"/"} aria-label={t('homepageLinkLabel')}>
                <Image
                  src={logoType === "original" ? "/stoneityLogo.png" : logoType === "green" ? "/stoneityLogoGreen.png" : ""}
                  className={styles.headerLogo}
                  alt=""
                  width={130}
                  height={32}
                  sizes="130px"
                />
              </Link>
              <div className={styles.menuLink} onClick={() => { setIsMenuOpen(true) }}>{t("products")}</div>
              <div className={styles.menuLinkWrapper} ref={sourcesMenuRef}>
                <div className={styles.menuLink}
                  onClick={() => {
                    setIsMenuOpen(false);
                    setIsSourcesMenuOpen(true);
                  }}>
                  {t("sources")}</div>
                <div className={`${styles.sourcesMenuContent} ${isSourcesMenuOpen ? styles.sourcesMenuContentActive : ""}`}>
                  <Link className={styles.headerProductsLogo} href={"/work-management/documents"}>
                    <ProductsIcon width="24px" height="24px" color="#FC584A" />
                    Work Management Docs
                  </Link>
                  <Link className={styles.headerProductsLogo} href={"/service-management/documents"}>
                    <ProductsIcon width="24px" height="24px" color="#478B5A" />
                    Service Management Docs
                  </Link>
                </div>
              </div>
            </div>
            : ""
          }
          <div className={styles.headerContentRight}>
            <div className={styles.languageWrapper} ref={languageMenuRef}>
              <div className={styles.languageButton}
                onClick={() => {
                  menuClose();
                  setIsLanguageMenuOpen(!isLanguageMenuOpen);
                }}>
                <Global color={color ? color : "#03555e"} />
                {router.locale?.toUpperCase()}
              </div>
              <div className={`${styles.languageButtonMenu} ${isLanguageMenuOpen ? styles.languageButtonMenuActive : ''}`}>
                <div className={styles.languageButtonMenuContent}>
                  <Link href={router.pathname} locale={"en"} onClick={() => { setIsLanguageMenuOpen(false) }}>EN</Link>
                  <Link href={router.pathname} locale={"tr"} onClick={() => { setIsLanguageMenuOpen(false) }}>TR</Link>
                </div>
              </div>
            </div>
            <Link className={styles.link} href={'/digital-forest'}>
              <StoneityButton
                buttonClass="digitalForestButton"
                buttonText={t('digitalForest')}
                iconPosition="start"
                icon={<Forest />}
                iconStyle={{ height: '24px' }}
                width={160}
                height={40}
              />
            </Link>
            {isTryDemoViewable &&
              <Link className={styles.link} locale={router.locale} href={'/try-demo'}>
                <StoneityButton
                  buttonClass={theme ? "greenFreeButton" : "freeButton"}
                  buttonText={t('tryItForFree')}
                  buttonStyle="dark"
                  width={150}
                  height={40}
                />
              </Link>
            }
            <div ref={responsiveMenuRef}>
              <div className={styles.responsiveMenuButton}>
                <input type="checkbox" id="checkbox" className={`${styles.checkbox} ${isResponsiveMenuOpen ? styles.active : ''} ${styles.buttonHidden}`} onClick={() => { menuClose(), setIsResponsiveMenuOpen(!isResponsiveMenuOpen) }} aria-label={t('menuToggleLabel')} />
                <label htmlFor="checkbox">
                  <div className={`${styles.hamburger} ${styles.hamburger3}`}>
                    <span className={`${styles.bar} ${styles.bar1}`}></span>
                    <span className={`${styles.bar} ${styles.bar2}`}></span>
                    <span className={`${styles.bar} ${styles.bar3}`}></span>
                    <span className={`${styles.bar} ${styles.bar4}`}></span>
                  </div>
                </label>
              </div>
              <div className={`${styles.responsiveMenu} ${isResponsiveMenuOpen ? styles.responsiveMenuActive : ''}`}>
                <div className={styles.menuLinkWrapper}>
                  <div className={styles.menuLinkFlex}>
                    <Link className={styles.menuLinkButton} href={'/digital-forest'}>
                      <StoneityButton
                        buttonClass="digitalForestButton"
                        buttonText={t('digitalForest')}
                        iconPosition="start"
                        icon={<Forest />}
                        iconStyle={{ height: '24px' }}
                        width={160}
                        height={40}
                      />
                    </Link>
                    {isTryDemoViewable &&
                      <Link className={styles.menuLinkButton} locale={router.locale} href={'/try-demo'}>
                        <StoneityButton
                          buttonClass={theme ? "greenFreeButton" : "freeButton"}
                          buttonText={t('tryItForFree')}
                          buttonStyle="dark"
                          width={150}
                          height={40}
                        />
                      </Link>
                    }
                  </div>
                  <Link className={styles.menuLink} locale={router.locale} href={"/"} onClick={() => { setIsResponsiveMenuOpen(false) }}>
                    {t('homepage')}
                  </Link>
                  <div className={`${styles.menuLink} ${isResponsiveScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div className={styles.menuLinkTop} onClick={() => {
                      responsiveProductMenuTabClose();
                      responsiveMenuTabClose();
                      setIsResponsiveScrollMenu(!isResponsiveScrollMenu);
                    }}>
                      {t("products")}
                      <Arrow rotate={isResponsiveScrollMenu ? "180deg" : ""} />
                    </div>
                    <div className={`${styles.responsiveProductMenuWrapper} ${isResponsiveScrollMenu ? styles.responsiveProductMenuWrapperActive : ''}`}>
                      <Link href={"/work-management"} className={styles.responsiveProductsMenuLink}
                        style={{
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="24" height="24" color="#FC584A" />
                          <span>Work Management</span>
                        </div>
                        {/* <Arrow rotate={isReponsiveWorkManagementSubMenuOpen ? "180deg" : ""} /> */}
                      </Link>
                      {/* <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isReponsiveWorkManagementSubMenuOpen ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        <Link className={styles.responsiveProductsMenuSubLinkItem} href={"/work-management"}>Work Management {t("homepage")}</Link>
                        {productsData[0]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={`${productsData[0].link}/${card.title.toLowerCase()}`}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {card.title}
                          </Link>
                        ))}
                      </div> */}
                      <Link href={"/service-management"} className={styles.responsiveProductsMenuLink}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="24" height="24" color="#478B5A" />
                          <span>Service Management</span>
                        </div>
                        {/* <Arrow rotate={isReponsiveServiceManagementSubMenuOpen ? "180deg" : ""} /> */}
                      </Link>
                      <Link href={"/bmc-helix-itsm"} className={styles.responsiveProductsMenuLink}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <img className={styles.headerProductsIcon} src="/bmc-helix-logo.svg" alt="" />
                          <span style={{ paddingTop: "2px" }}>ITSM</span>
                        </div>
                        {/* <Arrow rotate={isReponsiveServiceManagementSubMenuOpen ? "180deg" : ""} /> */}
                      </Link>
                      <Link href={"/bmc-helix-discovery"} className={styles.responsiveProductsMenuLink}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <img className={styles.headerProductsIcon} src="/bmc-helix-logo.svg" alt="" />
                          <span style={{ paddingTop: "2px" }}>Discovery</span>
                        </div>
                        {/* <Arrow rotate={isReponsiveServiceManagementSubMenuOpen ? "180deg" : ""} /> */}
                      </Link>
                      <Link href={"/bmc-control-m"} className={styles.responsiveProductsMenuLink}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <img className={styles.headerProductsIcon} src="/bmc-logo.svg" alt="" />
                          <span style={{ paddingTop: "3px" }}>Control-M</span>
                        </div>
                        {/* <Arrow rotate={isReponsiveServiceManagementSubMenuOpen ? "180deg" : ""} /> */}
                      </Link>
                      {/* <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isReponsiveServiceManagementSubMenuOpen ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        <Link className={styles.responsiveProductsMenuSubLinkItem} href={"/service-management"}>Service Management {t("homepage")}</Link>
                        {productsData[1]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={`${productsData[1].link}/${card.title.toLowerCase()}`}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {card.title}
                          </Link>
                        ))}
                      </div> */}
                      {/* <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveProductMenuTabClose();
                        setIsReponsiveDemoLibrarySubMenuOpen(!isReponsiveDemoLibrarySubMenuOpen);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>Demo Kütüphanesi</span>
                        </div>
                        <Arrow rotate={isReponsiveDemoLibrarySubMenuOpen ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isReponsiveDemoLibrarySubMenuOpen ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        <Link className={styles.responsiveProductsMenuSubLinkItem} href={""}>Demo Kütüphanesi {t("homepage")}</Link>
                        {productsData[2]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link} // hazır linkleri direkt kullanıyoruz
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {card.title}
                          </Link>
                        ))}
                      </div> */}
                    </div>
                  </div>
                  <div className={`${styles.menuLink} ${isResponsiveSolutionsScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div className={styles.menuLinkTop} onClick={() => {
                      responsiveMenuTabClose();
                      responsiveDemoLibraryMenuTabClose();
                      setIsResponsiveSolutionsScrollMenu(!isResponsiveSolutionsScrollMenu);
                    }}>
                      {t("solutions")}
                      <Arrow />
                    </div>
                    <div className={`${styles.responsiveProductMenuWrapper} ${isResponsiveSolutionsScrollMenu ? styles.responsiveProductMenuWrapperActive : ''}`}>
                      <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveDemoLibraryMenuTabClose();
                        setIsDemoLibraryFirst(!isDemoLibraryFirst);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>{t(`${solutionsData[0].title}`)}</span>
                        </div>
                        <Arrow rotate={isDemoLibraryFirst ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isDemoLibraryFirst ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        {solutionsData[0]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {t(`${card.title}`)}
                          </Link>
                        ))}
                      </div>
                      <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveDemoLibraryMenuTabClose();
                        setIsDemoLibrarySecond(!isDemoLibrarySecond);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>{t(`${solutionsData[1].title}`)}</span>
                        </div>
                        <Arrow rotate={isDemoLibrarySecond ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isDemoLibrarySecond ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        {solutionsData[1]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {t(`${card.title}`)}
                          </Link>
                        ))}
                      </div>
                      <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveDemoLibraryMenuTabClose();
                        setIsDemoLibraryThird(!isDemoLibraryThird);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>{t(`${solutionsData[2].title}`)}</span>
                        </div>
                        <Arrow rotate={isDemoLibraryThird ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isDemoLibraryThird ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        {solutionsData[2]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {t(`${card.title}`)}
                          </Link>
                        ))}
                      </div>
                      <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveDemoLibraryMenuTabClose();
                        setIsDemoLibraryFourth(!isDemoLibraryFourth);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>{t(`${solutionsData[3].title}`)}</span>
                        </div>
                        <Arrow rotate={isDemoLibraryFourth ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isDemoLibraryFourth ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        {solutionsData[3]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {t(`${card.title}`)}
                          </Link>
                        ))}
                      </div>
                      <div className={styles.responsiveProductsMenuLink} onClick={(() => {
                        responsiveDemoLibraryMenuTabClose();
                        setIsDemoLibraryFifth(!isDemoLibraryFifth);
                      })}
                        style={{
                          borderBottom: "0",
                          marginBottom: "0",
                          padding: "10px 10px 10px 15px"
                        }}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <span>{t(`${solutionsData[4].title}`)}</span>
                        </div>
                        <Arrow rotate={isDemoLibraryFifth ? "180deg" : ""} />
                      </div>
                      <div className={`${styles.responsiveProductsMenuSubLinkWrapper} ${isDemoLibraryFifth ? styles.responsiveProductsMenuSubLinkWrapperActive : ''}`}>
                        {solutionsData[4]?.cards?.map((card, index) => (
                          <Link
                            key={index}
                            href={card.link}
                            className={styles.responsiveProductsMenuSubLinkItem}
                          >
                            {t(`${card.title}`)}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.menuLink} ${isResponsiveFeaturesScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div className={styles.menuLinkTop}
                      onClick={() => {
                        responsiveMenuTabClose()
                        setIsResponsiveFeaturesScrollMenu(!isResponsiveFeaturesScrollMenu)
                      }}>
                      {t("features")}
                      <Arrow rotate={isResponsiveFeaturesScrollMenu ? "180deg" : ""} />
                    </div>
                    <div className={`${styles.responsiveProductMenuWrapper} ${isResponsiveFeaturesScrollMenu ? styles.responsiveProductMenuWrapperActive : ''}`}>
                      <Link className={styles.responsiveProductsMenuLink} href={"/work-management/features"}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="28" height="28" color="#FC584A" />
                          Work Management {t("features")}
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* <div className={`${styles.menuLink} ${isResponsiveWorkflowScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div style={{ padding: '10px 0', cursor: 'pointer' }}
                      onClick={() => {
                        responsiveMenuTabClose()
                        setIsResponsiveWorkflowScrollMenu(!isResponsiveWorkflowScrollMenu)
                      }}>
                      {t("readyMadeWorkflow")}
                    </div>
                    <div className={`${styles.responsiveTemplateMenuWrapper} ${isResponsiveWorkflowScrollMenu ? styles.responsiveTemplateMenuWrapperActive : ''}`}>
                      <Link className={styles.responsiveTemplatesMenuLink} href={"/work-management/template"}>
                        <ProductsIcon width="28" height="28" color="#FC584A" />
                        Work Management Template
                      </Link>
                      <Link className={styles.responsiveTemplatesMenuLink} href={"/service-management/template"}>
                        <ProductsIcon width="28" height="28" color="#478B5A" />
                        Service Management Template
                      </Link>
                    </div>
                  </div> */}
                  <div className={`${styles.menuLink} ${isResponsivePlanScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div className={styles.menuLinkTop}
                      onClick={() => {
                        responsiveMenuTabClose()
                        setIsResponsivePlanScrollMenu(!isResponsivePlanScrollMenu)
                      }}>
                      {t("plans")}
                      <Arrow rotate={isResponsivePlanScrollMenu ? "180deg" : ""} />
                    </div>
                    <div className={`${styles.responsiveProductMenuWrapper} ${isResponsivePlanScrollMenu ? styles.responsiveProductMenuWrapperActive : ''}`}>
                      <Link className={styles.responsiveProductsMenuLink} href={"/work-management/plan"}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="28" height="28" color="#FC584A" />
                          Work Management {t("plans")}
                        </div>
                      </Link>
                      <Link className={styles.responsiveProductsMenuLink} href={"/service-management/plan"}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="28" height="28" color="#478B5A" />
                          Service Management {t("plans")}
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className={`${styles.menuLink} ${isResponsiveSourcesScrollMenu ? styles.menuLinkScroll : ''}`} style={{ padding: '0' }}>
                    <div className={styles.menuLinkTop}
                      onClick={() => {
                        responsiveMenuTabClose()
                        setIsResponsiveSourcesScrollMenu(!isResponsiveSourcesScrollMenu)
                      }}>
                      {t("sources")}
                      <Arrow rotate={isResponsiveSourcesScrollMenu ? "180deg" : ""} />
                    </div>
                    <div className={`${styles.responsiveProductMenuWrapper} ${isResponsiveSourcesScrollMenu ? styles.responsiveProductMenuWrapperActive : ''}`}>
                      <Link className={styles.responsiveProductsMenuLink} href={"/work-management/documents"}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="28" height="28" color="#FC584A" />
                          Work Management Docs
                        </div>
                      </Link>
                      <Link className={styles.responsiveProductsMenuLink} href={"/service-management/documents"}>
                        <div className={styles.responsiveProductsMenuLinkLeft}>
                          <ProductsIcon width="28" height="28" color="#478B5A" />
                          Service Management Docs
                        </div>
                      </Link>
                      {/* <Link className={styles.responsiveProductsMenuLink} href={"/innerbox"}>
                        <ProductsIcon width="28" height="28" color="#304DDB" />
                        Innerbox
                      </Link> */}
                    </div>
                  </div>
                  {/* <Link locale={router.locale} href={"sources"} className={styles.menuLink} onClick={() => { setIsResponsiveMenuOpen(false) }}>{t("sources")}</Link> */}
                </div>
              </div>
              {/* <div className={`${styles.responsiveProductsMenu} ${isResponsiveMenuOpen && isMenuOpen ? styles.responsiveProductsMenuActive : ""}`}>
                <div className={`${styles.responsiveProductsWrapper}`}>
                  <div className={styles.responsiveProducts}>
                    <Link className={`${styles.responsiveProductsLogo}`} href={"/work-management"}>
                      <ProductsIcon color="#FC584A" />
                      Work Management
                    </Link>
                  </div>
                  <div className={styles.responsiveProducts}>
                    <Link className={`${styles.responsiveProductsLogo}`} href={"/service-management"}>
                      <ProductsIcon color="#478B5A" />
                      Service Management
                    </Link>
                  </div>
                  <div className={styles.responsiveProducts}>
                    <Link className={`${styles.responsiveProductsLogo}`} href={"/innerbox"}>
                      <ProductsIcon color="#304DDB" />
                      Innerbox
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className={`${styles.subMenuBackground}  ${isMenuOpen ? styles.subMenuBackgroundActive : ''}`} onClick={() => { setIsMenuOpen(false) }}>
          <div className={`${styles.subMenu} ${isMenuOpen ? styles.subMenuActive : ""}`} onClick={(e) => { e.stopPropagation() }}>
            <div className={styles.subMenuContent}>
              <>
                <div className={styles.subMenuFlex}>
                  {/* PRODUCT */}
                  <div className={styles.subMenuColumn}>
                    <div className={styles.subMenuTitle} style={{ fontSize: "18px" }}>{t("products")}</div>
                    <div className={styles.headerProductsFlex}>
                      {productsData.map((product) => {
                        if (product.id === "p3" && windowWidth < 1300) return null;

                        return (
                          <div
                            key={product.id}
                            className={`${styles.headerProductsWrapper} ${activeData.id === product.id ? styles.headerProductsWrapperActive : ''}`}
                            onClick={() => handleItemClick(product)}
                          >
                            <div className={styles.headerProducts}>
                              <div className={styles.headerProductsLogo} style={{ fontSize: "14px" }}>
                                {product.icon !== false && (
                                  <ProductsIcon color={product.color} width={"20px"} height={"20px"} />
                                )}
                                {product.logo &&
                                  <img className={styles.headerProductsIcon} src={product.logo} alt="" />
                                }
                                <span>{t(`${product.title}`)}</span>
                              </div>
                            </div>
                            <ProductRightArrow />
                          </div>
                        );
                      })}
                      {/* <div className={styles.headerProductsWrapper}>
                        <div className={styles.headerProductsWrapperLeft}>
                          <img className={styles.headerProductsIcon} src="/bmc-helix-logo.svg" alt="" />
                          <span>ITSM</span>
                        </div>
                        <ProductRightArrow />
                      </div>
                      <div className={styles.headerProductsWrapper}>
                        <div className={styles.headerProductsWrapperLeft}>
                          <img className={styles.headerProductsIcon} src="/bmc-helix-logo.svg" alt="" />
                          <span style={{ paddingTop: "1px" }}>Discovery</span>
                        </div>
                        <ProductRightArrow />
                      </div>
                      <div className={styles.headerProductsWrapper}>
                        <div className={styles.headerProductsWrapperLeft}>
                          <img className={styles.headerProductsIcon} style={{ height: "19.42px" }} src="/bmc-logo.svg" alt="" />
                          <span style={{ paddingTop: "0.5px" }}>Control-M</span>
                        </div>
                        <ProductRightArrow />
                      </div> */}
                    </div>
                  </div>
                  <div className={styles.subMenuColumnLine}></div>
                  {/* SOLUTIONS */}
                  <div className={styles.subMenuColumn}>
                    <div className={styles.subMenuTitle}>{t("solutions")}</div>
                    <div className={styles.headerProductsFlex}>
                      {solutionsData.map((solutions) => (
                        <div
                          key={solutions.id}
                          className={`${styles.headerProductsWrapper} ${activeData.id === solutions.id ? styles.headerProductsWrapperActive : ''}`}
                          onClick={() => handleItemClick(solutions)}
                        >
                          <div className={styles.headerProducts}>{t(`${solutions.title}`)}</div>
                          <ProductRightArrow />
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* <div className={styles.subMenuColumnLine}></div>
                  <Link className={styles.headerViewAllLink} href={""}>
                    {t("viewAllProduct")}
                    <RightArrow />
                  </Link> */}
                </div>
                <div className={styles.subMenuLine}></div>
                <div className={styles.subMenuMid}>
                  <div className={styles.headerProductSubMenuLogo}>
                    {activeData?.icon !== false && (
                      <ProductsIcon color={activeData?.color || "#478B5A"} width={"30px"} height={"30px"} />
                    )}
                    {activeData?.logo && (
                      <img className={styles.headerProductsSubMenuIcon} src={activeData.logo} alt="" />
                    )}
                    <span className={styles.headerProductSubMenuLogoTitle}>{t(`${activeData?.title}`)}</span>
                    <Link className={styles.headerProductSubMenuLogoExplain} href={`${activeData?.link}`}>{t(`${activeData?.buttonText}`)}</Link>
                  </div>
                  <div className={styles.subMenuMidContent}>
                    <div className={styles.subMenuMidSubTextWrapper}>
                      <div className={styles.subMenuMidSubExplain}>{t(`${activeData?.explain}`)}</div>
                    </div>
                    {activeData?.library ?
                      <div className={styles.subMenuMidDemoCardWrapper}>
                        {activeData?.cards?.map((demoCard, index) => (
                          <Link key={index} className={styles.subMenuDemoCard} href={demoCard.link}>
                            {/* <img src={demoCard.img} alt="" /> */}
                            <Image
                              src={`${IMAGE_DELIVERY}/${demoCard.img}`}
                              alt={""}
                              width={195}
                              height={130}
                              loader={(p: ImageLoaderProps) => imageLoader(p.src, 195, 130)}
                            />
                            <div className={styles.subMenuDemoCardTextWrapper}>
                              <div className={styles.subMenuDemoCardTitle}>{demoCard.title}</div>
                              <div className={styles.subMenuDemoCardText}>{t(`${demoCard.desc}`)}</div>
                            </div>
                          </Link>
                        ))}
                      </div>
                      :
                      <div className={styles.subMenuMidContentCardWrapper}>
                        {activeData?.cards?.map((card, index) => (
                          <Link key={index} className={styles.subMenuMidContentCard} href={`${card.link}`}>
                            <div className={styles.subMenuMidContentCardTop}>
                              <div className={styles.subMenuMidContentCardIconWrapper}>
                                <SolutionIcon />
                              </div>
                              <span>{t(`${card.title}`)}</span>
                            </div>
                            <div className={styles.subMenuMidContentCardExplain}>
                              {t(`${card.desc}`)}
                            </div>
                          </Link>
                        ))}
                      </div>
                    }
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </header >
      {/* {
        isMenuOpen &&
        <div className={`${styles.headerProductsWrapper} ${isMenuOpen ? styles.headerProductsWrapperActive : ''}`}>
          <div className={styles.headerContent}>
            <div className={`${styles.headerContentLeft} ${styles.headerProductsContent}`}>
              <div className={styles.headerProducts}>
                <Link className={`${styles.headerProductsLogo}`} href={"/work-management"}>
                  <ProductsIcon color="#FC584A" />
                  Work Management
                </Link>
              </div>
              <div className={styles.headerProducts}>
                <Link className={`${styles.headerProductsLogo}`} href={"/service-management"}>
                  <ProductsIcon color="#478B5A" />
                  Service Management
                </Link>
              </div>
              <div className={styles.headerProducts}>
                <Link className={`${styles.headerProductsLogo}`} href={"/innerbox"}>
                  <ProductsIcon color="#304DDB" />
                  Innerbox
                </Link>
              </div>
            </div>
          </div>
        </div>
      } */}
      {
        workMagamentPathname &&
        <div className={`${styles.headerSpecialProductsWrapper} ${isScrolled ? styles.headerSpecialProductsWrapperActive : ''}`}>
          <div className={styles.headerContent}>
            <div className={`${styles.headerContentLeft} ${styles.headerProductsContent}`}>
              <div className={styles.headerProducts}>
                {
                  !isScrolled && <Link className={`${styles.headerProductsLogo}`} href={"/work-management"}>
                    <ProductsIcon color="#FC584A" />
                    <div className={styles.headerProductName}>Work Management</div>
                  </Link>
                }
                <div className={styles.responsiveHeaderProductsMenu}>
                  <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/features") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/work-management/features"}>{t('features')}</Link>
                  <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/plan") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/work-management/plan"}>{t('plans')}</Link>
                  <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/documents") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/work-management/documents"}>{t('documents')}</Link>
                  {/* <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/template") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/work-management/template"}>Template</Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        ||
        serviceMagamentPathname &&
        <div className={`${styles.headerSpecialProductsWrapper} ${isScrolled ? styles.headerSpecialProductsWrapperActive : ''}`}>
          <div className={styles.headerContent}>
            <div className={`${styles.headerContentLeft} ${styles.headerProductsContent}`}>
              <div className={styles.headerProducts}>
                {
                  !isScrolled && <Link className={`${styles.headerProductsLogo}`} href={"/service-management"}>
                    <ProductsIcon color="#478B5A" />
                    <div className={styles.headerProductName}>Service Management</div>
                  </Link>
                }
                <div className={styles.responsiveHeaderProductsMenu}>
                  {/* <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/features") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/service-management/features"}>{t('features')}</Link> */}
                  <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/plan") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/service-management/plan"}>{t('plans')}</Link>
                  <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/documents") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/service-management/documents"}>{t('documents')}</Link>
                  {/* <Link className={`${styles.responsiveMenuLink} ${router.pathname.endsWith("/template") ? styles.responsiveMenuLinkActive : ""} ${styles[theme ? theme : '']}`} locale={router.locale} href={"/service-management/template"}>Template</Link> */}
                </div>

              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default Header;
